import { parseApiError } from './error';
export class ApiHttpClient {
    config;
    constructor(config) {
        this.config = config;
    }
    get = createHttpMethod((path, options) => this.request('GET', path, options));
    post = createHttpMethod((path, options) => this.request('POST', path, options));
    put = createHttpMethod((path, options) => this.request('PUT', path, options));
    patch = createHttpMethod((path, options) => this.request('PATCH', path, options));
    delete = createHttpMethod((path, options) => this.request('DELETE', path, options));
    async request(method, path, options) {
        const { body, json, query, headers: requestHeaders, response: responseType = 'json', ...requestOptions } = options;
        const url = this.buildUrl(path, query);
        const token = await this.config.getToken();
        const headers = new Headers(await this.config.getHeaders?.());
        const sendsJson = 'json' in options;
        if (sendsJson)
            headers.set('Content-Type', 'application/json');
        new Headers(requestHeaders).forEach((value, key) => headers.set(key, value));
        headers.set('Authorization', `Bearer ${token}`);
        const requestBody = sendsJson ? JSON.stringify(json) : body;
        const response = await fetch(url, {
            ...requestOptions,
            headers,
            method,
            body: requestBody,
        });
        if (!response.ok) {
            const error = await parseApiError(response, url);
            this.config.onError?.(error);
            throw error;
        }
        switch (responseType) {
            case 'raw':
                return response;
            case 'text':
                return response.text();
            case 'json':
                return response.json();
            case 'content-type-or-empty':
            case 'content-type': {
                if (responseType === 'content-type-or-empty' && (method === 'PATCH' || response.status === 204))
                    return undefined;
                const contentType = response.headers.get('Content-Type');
                const data = contentType?.includes('application/json')
                    ? await response.json()
                    : contentType?.includes('text/csv')
                        ? await response.blob()
                        : undefined;
                return response.status === 204 ? undefined : data;
            }
        }
    }
    buildUrl(path, query) {
        const url = new URL(path, this.config.baseUrl);
        if (query) {
            Object.entries(query).forEach(([key, value]) => value !== undefined && url.searchParams.append(key, String(value)));
        }
        return url.toString();
    }
    async postFile(path, file, options) {
        const formData = new FormData();
        formData.append('file', file);
        return this.post(path, { ...options, body: formData });
    }
}
export function createHttpMethod(execute) {
    function request(path, options = {}) {
        return execute(path, options);
    }
    return request;
}
